import { getAlertBasicReducers } from "../components/Alert/modul/alertBasicReducers";

const generalStore = {
  getAlertBasic: getAlertBasicReducers,
};

export default generalStore;
